_ = require 'underscore'
pluginValidators = require 'lib/plugins/plugin-validators'
PluginView = require 'views/plugin/plugin-view'
Util = require 'lib/util'

module.exports = class PluginButtonView extends PluginView
  tagName: ->
    if @options.pluginButton.url? then 'a' else 'span'

  attributes: ->
    { url, target } = @options.pluginButton
    if url && pluginValidators.isValidUrlForIframe(url)
      href: url
      target: target ? url
      rel: 'noreferrer nofollow noopener'

  initialize: ({ @pluginButton }) ->
    @retain(@pluginButton)

  events:
    'click': (e) ->
      Util.stopPropagation(e)
      @trackClick?(@pluginButton)
      if @pluginButton.callback?
        @pluginButton.callback
          el: e.currentTarget
        .done()

  template: ->
    throw Error('no template specified')

  renderOnce: ->
    @$el.html(@template(@pluginButton))
    @



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-button-view.coffee